import React, { useState, useEffect } from "react";
import placeholder from "../../assets/noimage.png";

const CandidateImage = ({ imageUrl, imageUrlFallback }) => {
  const [imgUrl, setImgUrl] = useState("");

  useEffect(() => {
    // Fetch the image and check if it exists
    fetch(imageUrl)
      .then((res) => {
        if (res.status === 200) {
          setImgUrl(imageUrl);
        } else {
          setImgUrl(placeholder);
        }
      })
      .catch(() => {
        setImgUrl(placeholder);
      });
  }, [imageUrl]);

  return (
    <picture>
      <source
        srcSet={imgUrl}
        type="image/webp"
        onError={() => {
          setImgUrl(imageUrlFallback);
        }}
      />
      <img
        src={imgUrl}
        alt=""
        onError={() => {
          setImgUrl(placeholder);
        }}
        width="53px"
        height="53px"
        className="mr-5 rounded-full bg-white"
      />
    </picture>
  );
};

export default CandidateImage;
